import {
  GetReadablesTermsDocument,
  GetReadablesTermsQuery,
  GetReadablesTermsQueryVariables,
  LocaleEnum,
  Metadata,
  MetadataDocument,
  MetadataQuery,
  MetadataQueryVariables,
  PageEnum,
  Readable,
  SearchReadablesDocument,
  SearchReadablesQuery,
  SearchReadablesQueryVariables,
} from 'generated/apolloComponents'
import React, { useReducer } from 'react'
import { addApolloState, initializeApollo } from '@/api/apollo'
import BlogMain from '@/components/templates/Blog/Blog'
import {
  BlogContext,
  blogReducer,
  convertBlogStateFiltersToQueryFilters,
  initialBlogState,
} from '@/context/blogContext'
import { convertSlugToState } from '@/helpers/filters'
import CustomHead from '@/components/molecules/CustomHead'

interface IProps {
  last?: Readable
  filteredData?: Readable[] | null
  totalCount?: number
  slugState: any
  categories: any
  metaData: Metadata
}

const Blog = ({
  last,
  filteredData = null,
  slugState,
  totalCount,
  categories,
  metaData,
}: IProps) => {
  const [state, dispatch] = useReducer(blogReducer, initialBlogState)

  return (
    <>
      <CustomHead metaData={metaData} />

      <main className='mt-14'>
        <div className='container'>
          <BlogContext.Provider value={{ state, dispatch }}>
            <BlogMain
              last={last}
              slugState={slugState}
              filteredData={filteredData}
              totalCount={totalCount}
              categories={categories}
            />
          </BlogContext.Provider>
        </div>
      </main>
    </>
  )
}

export const getServerSideProps = async (context: any) => {
  const page: number = 1
  const perPage: number = 12
  const apolloClient = initializeApollo({ ctx: context })

  const stateBySlug = convertSlugToState(context.query.slug, { page, perPage })
  const queryByState = convertBlogStateFiltersToQueryFilters(
    stateBySlug.filters
  )
  let data = {}

  const categoriesData = await apolloClient.query<
    GetReadablesTermsQuery,
    GetReadablesTermsQueryVariables
  >({
    query: GetReadablesTermsDocument,
    variables: {
      language: LocaleEnum[context.locale as 'pl' | 'en'],
    },
  })

  const metaData = await apolloClient.query<
    MetadataQuery,
    MetadataQueryVariables
  >({
    query: MetadataDocument,
    variables: {
      pageType: PageEnum.ReadableList,
      language: LocaleEnum[context.locale as 'pl' | 'en'],
      readableFilters: queryByState,
    },
  })

  const filteredData = await apolloClient.query<
    SearchReadablesQuery,
    SearchReadablesQueryVariables
  >({
    query: SearchReadablesDocument,
    variables: {
      page: stateBySlug.page || page,
      perPage: perPage,
      filters: queryByState,
      language: LocaleEnum[context.locale as 'pl' | 'en'],
    },
  })

  data = {
    last: null,
    metaData: metaData.data.metadata,
    key: context.query.slug || null,
    slugState: stateBySlug,
    filteredData: filteredData.data.searchReadables.nodes,
    totalCount: filteredData.data.searchReadables.totalCount,
    categories: categoriesData.data.getReadablesTerms,
  }

  return addApolloState(apolloClient, {
    props: data,
  })
}

export default Blog
